var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20319",
    "data-name": "Group 20319",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.675,
    height: 13.398,
    viewBox: "0 0 13.675 13.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33199",
    "data-name": "Path 33199",
    d: "M-2611.237-3260.255V-3251h11.375v-8.034h-3.611v-4.523h-.917Z",
    transform: "translate(2612.673 3263.954)",
    fill: "#535353",
    opacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33194",
    "data-name": "Path 33194",
    d: "M.915,12.494V3.84a1,1,0,0,1,.7-1.054L8.165.093a.983.983,0,0,1,1.407.943V4.292h2.587A.987.987,0,0,1,13.217,5.35v7.129c.354.087.521.32.434.6a.447.447,0,0,1-.407.323.858.858,0,0,1-.1,0H.527a.483.483,0,0,1-.487-.274.451.451,0,0,1,.4-.635C.591,12.486.744,12.494.915,12.494Zm7.749-.008V1.071c0-.175-.023-.19-.194-.118Q5.223,2.288,1.976,3.623a.207.207,0,0,0-.152.228q.006,4.24,0,8.483v.152Zm3.64,0c0-.038,0-.068,0-.1q0-3.515,0-7.03c0-.129-.046-.16-.167-.16-.818,0-1.632,0-2.45,0H9.58V12.49c.909,0,1.811,0,2.724,0Z",
    transform: "translate(0.001 -0.002)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33195",
    "data-name": "Path 33195",
    d: "M97.673,125.593h-1.1a.459.459,0,1,1,.008-.913h2.18a.457.457,0,1,1,0,.909C98.392,125.593,98.03,125.593,97.673,125.593Z",
    transform: "translate(-92.424 -119.937)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33196",
    "data-name": "Path 33196",
    d: "M97.57,173.589h-1.1a.456.456,0,1,1,0-.909h2.191a.457.457,0,1,1,0,.909Z",
    transform: "translate(-92.329 -166.111)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33197",
    "data-name": "Path 33197",
    d: "M97.581,220.537h1.1a.457.457,0,1,1,.008.913H96.463A.457.457,0,0,1,95.98,221a.465.465,0,0,1,.491-.46C96.844,220.533,97.212,220.537,97.581,220.537Z",
    transform: "translate(-92.329 -212.147)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33198",
    "data-name": "Path 33198",
    d: "M97.661,269.293h-1.08a.459.459,0,1,1,0-.913h2.191a.458.458,0,1,1,0,.913C98.4,269.3,98.03,269.293,97.661,269.293Z",
    transform: "translate(-92.424 -258.171)",
    fill: "#535353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/Icon_Company.2068f2f9c513fb97ee4f402cf8b6f043.svg";
export { ForwardRef as ReactComponent };